<template>
  <div class="kt-portlet kt-portlet--mobile" style="min-width: 2500px !important;">
    <router-view />
    <div class="kt-form">
      <!--begin::Form-->
      <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
             <div class="row">
              <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>ปีงบประมาณ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'searchYear'"
                    :name="'searchYear'"
                    :select2-options="yearOptions"
                    v-model="searchYear"
                    ref="yearSelect2"
                  ></select2>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <treeselect
                    v-model="searchAgentCode"
                    :multiple="true"
                    :options="searchAgentOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>
             <div class="row">
                <div class="col-xl-12" style="max-height: calc(100vh - 260px); overflow: auto;">
                     <table class="table table-sm  table-bordered  " id="agentScore" >
                            <thead>
                            <tr>
                              <th scope="col" rowspan="2" class="TH">NO</th>
                              <th scope="col" rowspan="2" class="TH">ปี</th>
                              <th scope="col" rowspan="2" class="TH">รหัส</th>
                              <th scope="col" rowspan="2" class="TH">ชื่อตัวแทนจำหน่าย</th> 
                              <th scope="col" colspan="12" class="TH THMAC">คะแนนถังคงค้าง</th>
                              <th scope="col" colspan="12" class="TH THSYS">คะแนนการทำระบบเบียร์สด</th>
                              <th scope="col" colspan="13" class="TH THTOT">รวมคะแนน</th> 

                              <th scope="col" rowspan="2" class="TH">สถานะรายการ</th>
                              <th scope="col" rowspan="2" class="TH">คำสั่ง</th> 
                            </tr>
                            <tr>
                              <th scope="col"  class="TH THMAC">ม.ค.</th>
                              <th scope="col"  class="TH THMAC">ก.พ.</th>
                              <th scope="col"  class="TH THMAC">มี.ค.</th>
                              <th scope="col"  class="TH THMAC">เม.ย.</th>
                              <th scope="col"  class="TH THMAC">พ.ค.</th>
                              <th scope="col"  class="TH THMAC">มิ.ย.</th>
                              <th scope="col"  class="TH THMAC">ก.ค.</th>
                              <th scope="col"  class="TH THMAC">ส.ค.</th>
                              <th scope="col"  class="TH THMAC">ก.ย.</th>
                              <th scope="col"  class="TH THMAC">ต.ค.</th>
                              <th scope="col"  class="TH THMAC">พ.ย.</th>
                              <th scope="col"  class="TH THMAC">ธ.ค.</th>

                              <th scope="col"  class="TH THSYS">ม.ค.</th>
                              <th scope="col"  class="TH THSYS">ก.พ.</th>
                              <th scope="col"  class="TH THSYS">มี.ค.</th>
                              <th scope="col"  class="TH THSYS">เม.ย.</th>
                              <th scope="col"  class="TH THSYS">พ.ค.</th>
                              <th scope="col"  class="TH THSYS">มิ.ย.</th>
                              <th scope="col"  class="TH THSYS">ก.ค.</th>
                              <th scope="col"  class="TH THSYS">ส.ค.</th>
                              <th scope="col"  class="TH THSYS">ก.ย.</th>
                              <th scope="col"  class="TH THSYS">ต.ค.</th>
                              <th scope="col"  class="TH THSYS">พ.ย.</th>
                              <th scope="col"  class="TH THSYS">ธ.ค.</th>

                              <th scope="col"  class="TH THTOT">ม.ค.</th>
                              <th scope="col"  class="TH THTOT">ก.พ.</th>
                              <th scope="col"  class="TH THTOT">มี.ค.</th>
                              <th scope="col"  class="TH THTOT">เม.ย.</th>
                              <th scope="col"  class="TH THTOT">พ.ค.</th>
                              <th scope="col"  class="TH THTOT">มิ.ย.</th>
                              <th scope="col"  class="TH THTOT">ก.ค.</th>
                              <th scope="col"  class="TH THTOT">ส.ค.</th>
                              <th scope="col"  class="TH THTOT">ก.ย.</th>
                              <th scope="col"  class="TH THTOT">ต.ค.</th>
                              <th scope="col"  class="TH THTOT">พ.ย.</th>
                              <th scope="col"  class="TH THTOT">ธ.ค.</th> 

                              <th scope="col"  class="TH">Total</th>  

                            </tr>

                          </thead>
                           
                          <tbody>
                              <template v-for="(item, i) in dataSource">
                                  <tr>
                                    <td class="text-center align-middle TITLE">{{ i + 1 }}</td>
                                    <td class="text-center align-middle TITLE">{{ item.year }}</td> 
                                    <td class="text-center align-middle TITLE">{{ item.agentCode }}</td> 
                                    <td class="text-left align-middle" style="min-width:250px !important;">{{ item.agentName }}</td>   
                                   
                                    <td class="text-center align-middle MAC">
                                       <i v-if="item.maC_JAN_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                       <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,1,'MACHINE',item.maC_JAN,item.maC_JAN_Remark)" >{{ (item.maC_JAN !=null) ? item.maC_JAN : '-'}} </a>
                                    </td>
                                    <td class="text-center align-middle MAC">
                                      <i v-if="item.maC_FEB_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                      <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,2,'MACHINE',item.maC_FEB,item.maC_FEB_Remark)" >{{ (item.maC_FEB !=null) ? item.maC_FEB  : '-'}}  </a>
                                    </td>
                                    <td class="text-center align-middle MAC">
                                       <i v-if="item.maC_MAR_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                       <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,3,'MACHINE',item.maC_MAR,item.maC_MAR_Remark)" >{{(item.maC_MAR !=null) ?  item.maC_MAR : '-' }}  </a>
                                    </td>
                                    <td class="text-center align-middle MAC">
                                        <i v-if="item.maC_APR_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                        <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,4,'MACHINE',item.maC_APR,item.maC_APR_Remark)" >{{ (item.maC_APR !=null) ? item.maC_APR : '-' }}  </a>
                                    </td>
                                    <td class="text-center align-middle MAC">
                                      <i v-if="item.maC_MAY_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                      <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,5,'MACHINE',item.maC_MAR,item.maC_MAY_Remark)" >{{ (item.maC_MAY !=null) ? item.maC_MAY  : '-'}}  </a>
                                    </td>
                                    <td class="text-center align-middle MAC">
                                      <i v-if="item.maC_JUN_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                      <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,6,'MACHINE',item.maC_JUN,item.maC_JUN_Remark)" >{{ (item.maC_JUN !=null) ? item.maC_JUN : '-' }} </a>
                                    </td>
                                    <td class="text-center align-middle MAC">
                                      <i v-if="item.maC_JUL_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                      <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,7,'MACHINE',item.maC_JUL,item.maC_JUL_Remark)" >{{ (item.maC_JUL !=null) ? item.maC_JUL : '-' }}  </a>
                                    </td>
                                    <td class="text-center align-middle MAC">
                                      <i v-if="item.maC_AUG_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                      <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,8,'MACHINE',item.maC_AUG,item.maC_AUG_Remark)" >{{(item.maC_AUG !=null) ?  item.maC_AUG : '-' }}  </a>
                                    </td>
                                    <td class="text-center align-middle MAC">
                                      <i v-if="item.maC_SEP_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                      <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,9,'MACHINE',item.maC_SEP,item.maC_SEP_Remark)" >{{ (item.maC_SEP !=null) ? item.maC_SEP : '-' }} </a>
                                    </td>
                                    <td class="text-center align-middle MAC">
                                      <i v-if="item.maC_OCT_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                      <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,10,'MACHINE',item.maC_OCT,item.maC_OCT_Remark)" >{{ (item.maC_OCT !=null) ? item.maC_OCT : '-' }}  </a>
                                    </td>
                                    <td class="text-center align-middle MAC">
                                      <i v-if="item.maC_NOV_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                      <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,11,'MACHINE',item.maC_NOV,item.maC_NOV_Remark)" >{{ (item.maC_NOV !=null) ? item.maC_NOV : '-' }}  </a>
                                    </td>
                                    <td class="text-center align-middle MAC">
                                      <i v-if="item.maC_DEC_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                      <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,12,'MACHINE',item.maC_DEC,item.maC_DEC_Remark)" >{{ (item.maC_DEC !=null) ? item.maC_DEC : '-' }}  </a>
                                    </td>



                                    <td class="text-center align-middle SYS">
                                       <i v-if="item.syS_JAN_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                       <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,1,'SYSTEM',item.syS_JAN,item.syS_JAN_Remark)" >{{ (item.syS_JAN !=null) ? item.syS_JAN : '-'    }} </a>
                                    </td>
                                    <td class="text-center align-middle SYS">
                                      <i v-if="item.syS_FEB_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                      <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,2,'SYSTEM',item.syS_FEB,item.syS_FEB_Remark)" >{{ (item.syS_FEB !=null) ? item.syS_FEB : '-'  }}  </a>
                                    </td>
                                    <td class="text-center align-middle SYS">
                                       <i v-if="item.syS_MAR_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                       <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,3,'SYSTEM',item.syS_MAR,item.syS_MAR_Remark)" >{{ (item.syS_MAR !=null) ? item.syS_MAR: '-'   }} </a>
                                    </td>
                                    <td class="text-center align-middle SYS">
                                        <i v-if="item.syS_APR_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                        <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,4,'SYSTEM',item.syS_APR,item.syS_APR_Remark)" >{{ (item.syS_APR !=null) ? item.syS_APR: '-'   }}  </a>
                                    </td>
                                    <td class="text-center align-middle SYS">
                                      <i v-if="item.syS_MAY_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                      <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,5,'SYSTEM',item.syS_MAR,item.syS_MAY_Remark)" >{{ (item.syS_MAY !=null) ? item.syS_MAY: '-'   }} </a>
                                    </td>
                                    <td class="text-center align-middle SYS">
                                      <i v-if="item.syS_JUN_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                      <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,6,'SYSTEM',item.syS_JUN,item.syS_JUN_Remark)" >{{ (item.syS_JUN !=null) ? item.syS_JUN: '-'   }}  </a>
                                    </td>
                                    <td class="text-center align-middle SYS">
                                      <i v-if="item.syS_JUL_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                      <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,7,'SYSTEM',item.syS_JUL,item.syS_JUL_Remark)" >{{ (item.syS_JUL !=null) ? item.syS_JUL: '-'   }}  </a>
                                    </td>
                                    <td class="text-center align-middle SYS">
                                      <i v-if="item.syS_AUG_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                      <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,8,'SYSTEM',item.syS_AUG,item.syS_AUG_Remark)" >{{(item.syS_AUG !=null) ?  item.syS_AUG: '-'   }}  </a>
                                    </td>
                                    <td class="text-center align-middle SYS">
                                      <i v-if="item.syS_SEP_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                      <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,9,'SYSTEM',item.syS_SEP,item.syS_SEP_Remark)" >{{ (item.syS_SEP !=null) ? item.syS_SEP: '-'   }}  </a>
                                    </td>
                                    <td class="text-center align-middle SYS">
                                      <i v-if="item.syS_OCT_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                      <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,10,'SYSTEM',item.syS_OCT,item.syS_OCT_Remark)" >{{(item.syS_OCT !=null) ?  item.syS_OCT : '-'  }}  </a>
                                    </td>
                                    <td class="text-center align-middle SYS">
                                      <i v-if="item.syS_NOV_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                      <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,11,'SYSTEM',item.syS_NOV,item.syS_NOV_Remark)" >{{ (item.syS_NOV !=null) ? item.syS_NOV : '-'  }}  </a>
                                    </td>
                                    <td class="text-center align-middle SYS">
                                      <i v-if="item.syS_DEC_STATUS === 'APPROVE'" class="fas fa-check-circle approved-icon" title="อนุมัติแล้ว"></i>
                                      <a href="#" title="กดเพื่อแก้ไขข้อมูล" @click.prevent="showModal(item.evaluationId,12,'SYSTEM',item.syS_DEC,item.syS_DEC_Remark)" >{{ (item.syS_DEC !=null) ? item.syS_DEC: '-'   }}  </a>
                                    </td>

                                    <td class="text-center align-middle TOT">{{ (item.totaL_JAN != null) ? item.totaL_JAN : '-' }}</td>
                                    <td class="text-center align-middle TOT">{{ (item.totaL_FEB != null) ? item.totaL_FEB : '-' }}</td>
                                    <td class="text-center align-middle TOT">{{ (item.totaL_MAR != null) ? item.totaL_MAR : '-' }}</td>
                                    <td class="text-center align-middle TOT">{{ (item.totaL_APR != null) ? item.totaL_APR : '-' }}</td>
                                    <td class="text-center align-middle TOT">{{ (item.totaL_MAY != null) ? item.totaL_MAY : '-' }}</td>
                                    <td class="text-center align-middle TOT">{{ (item.totaL_JUN != null) ? item.totaL_JUN : '-' }}</td>
                                    <td class="text-center align-middle TOT">{{ (item.totaL_JUL != null) ? item.totaL_JUL : '-' }}</td>
                                    <td class="text-center align-middle TOT">{{ (item.totaL_AUG != null) ? item.totaL_AUG : '-' }}</td>
                                    <td class="text-center align-middle TOT">{{ (item.totaL_SEP != null) ? item.totaL_SEP : '-' }}</td>
                                    <td class="text-center align-middle TOT">{{ (item.totaL_OCT != null) ? item.totaL_OCT : '-' }}</td>
                                    <td class="text-center align-middle TOT">{{ (item.totaL_NOV != null) ? item.totaL_NOV : '-' }}</td>
                                    <td class="text-center align-middle TOT">{{ (item.totaL_DEC != null) ? item.totaL_DEC : '-' }}</td>

                                    <td class="text-center align-middle TOT">{{ item.grandTotal }}</td>

                                    <td class="text-center align-middle">
                                      <span v-if="item.statusCode == 'SAVE'" class="text-warning"><i class="fa fa-check-fa fa-sync-alt"></i> {{ item.statusText }}</span>
                                      <span v-if="item.statusCode == 'APPROVE'" class="text-success"><i class="fa fa-check-circle"></i> {{ item.statusText }}</span>
                                    </td>
                                    <td class="text-center align-middle">
                                       <a v-if="item.statusCode == 'SAVE'"  href="#"  @click.prevent="ApproveJobAgentEvaluation(item.evaluationId,'APPROVE')" title="สถานะบันทึกรายการ" class="btn btn-sm btn-clean btn-icon btn-icon-md">
                                        <i class="fas fa-chart-line kt-font-warning"></i> 
                                       </a>
                                       <a v-if="item.statusCode == 'APPROVE'"  href="#" @click.prevent="ApproveJobAgentEvaluation(item.evaluationId,'APPROVE')"  title="สถานะแสดงผลที่ Dashboard" class="btn btn-sm btn-clean btn-icon btn-icon-md">
                                         <i class="fas fa-chart-line kt-font-success"></i>
                                       </a>
                                    </td>

                                  </tr>
                                </template>
                            </tbody>
                    </table>
                </div>
             </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="$router.go(-1)"
          >
            <i class="la la-close"></i> ย้อนกลับ
          </button>
          <button type="button" @click.prevent="ApproveJobAgentEvaluationALL()" class="btn btn-primary"  >
            <i class="fas fa-chart-line"></i> อนุมัติทั้งหมด
          </button>
          <!-- <button type="button" class="btn btn-success">
            <i class="flaticon-paper-plane-1"></i> ส่งขออนุมัติ
          </button>-->
        </div>
      </form>
      <!--end::Form-->
    </div>

    <!-------Start Modal--> 
    <div class="modal fade" id="EditModal" tabindex="-1" role="dialog" aria-labelledby="EditModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content mr-4">
        <div class="modal-header">
          <h5 class="modal-title">แก้ไขคะแนน</h5>
          <button type="button" class="close" aria-label="Close" @click="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body"> 
          <div class="row">
            <div class="col-xl-12">
              <form
                  autocomplete="off"
                  class="kt-form"
                  id="editForm"
                  ref="editForm"
                  @submit="formSubmit2"
                >

                <div>
                  <div class="kt-section__body">
                    <div class="row">
                     
                      <div class="col-sm-3 col-md-3 col-xl-3">
                        <div class="form-group mb-0">
                          <label class="label"
                            >คะแนน (ปัจจุบัน) <em class="text-danger">*</em> :</label
                          >
                          <input
                            readonly="readonly"
                            v-model="currentScore"
                            type="number"
                            style="background-color: #eeeeee !important;"
                            class="form-control"
                            placeholder="คะแนน"
                          />
                        </div>
                      </div>  
                       <div class="col-sm-3 col-md-3 col-xl-3">
                        <div class="form-group mb-0">
                          <label class="label"
                            >คะแนน (ที่ต้องการแก้ไข) <em class="text-danger">*</em> :</label
                          >
                          <input
                            v-model="currentScoreNew"
                            id="currentScoreNew"
                            name="currentScoreNew"
                            type="number"
                            min="0"
                            class="form-control"
                            placeholder="คะแนน"
                          />
                        </div>
                      </div>  
                      <div class="col-sm-12 col-md-12 col-xl-12">
                        <div class="form-group mb-0">
                          <input type="hidden" class="form-control" v-model="currentMonth"></input>
                          <input type="hidden" class="form-control" v-model="currentTypeCode"></input>
                          
                          <label class="label"
                            >หมายเหตุ <em class="text-danger">*</em> :</label
                          >
                          <input
                            v-model="currentRemark"
                            type="text"
                             id="currentRemark" 
                            name="currentRemark" 
                            class="form-control"
                            placeholder="หมายเหตุ"
                          />
                        </div>
                      </div>  
                    </div> 
                  </div>
                </div>

                <div class="modal-footer border-0">
                <button type="button"    @click.prevent="SaveCommentEdit"   class="btn btn-primary" > <i class="la la-save"></i> บันทึกข้อมูล
                </button>
                <button type="button" data-dismiss="modal" class="btn btn-secondary"  aria-label="Close" @click="closeModal"><i class="la la-close"></i> ยกเลิก
                </button>
              </div>

              </form>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12 pt-0">
                  <div>
                    <h4>ประวัติการแก้ไข : </h4>
                  </div>
                  <table class="table table-sm  table-bordered  " >
                            <thead>
                           
                            <tr> 
                              <th scope="col"  class="text-center">วันที่</th>
                              <th scope="col"  class="text-center">คะแนน(ก่อน)</th>
                              <th scope="col"  class="text-center">คะแนน (หลัง)</th>
                              <th scope="col"  class="text-center">หมายเหตุ</th>
                              <th scope="col"  class="text-center">ผู้ดำเนินการ</th> 
                            </tr>

                          </thead>
                           
                          <tbody>
                             <tr v-if="dataSourceRemark==null || dataSourceRemark.length <= 0">
                              <td colspan="5" class="text-center">
                                <h6>ไม่พบข้อมูลการแก้ไข</h6>
                              </td>
                             </tr>
                              <template v-for="(hist, i) in dataSourceRemark">
                                  <tr>
                                     
                                    <td class="text-center align-middle">{{ hist.createdDateText }}</td>
                                    <td class="text-center align-middle">{{ hist.oldScore }}</td>
                                    <td class="text-center align-middle">{{ hist.newScore }}</td>
                                    <td class="text-left align-middle">{{ hist.remark }}</td>
                                    <td class="text-left align-middle">{{ hist.fullName }}</td> 

                                  </tr>
                                </template>
                            </tbody>
                    </table>
            </div>
          </div> 
        </div>
        
      </div>
    </div>
    </div>
    <!-------End Modal--> 


  </div>

 

</template>

<style>
.TH {
  background: #ccc  !important;
  text-align: center !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  font-family: Noto Sans Thai UI;
  vertical-align: middle !important;
}
.THMAC {
  background: #C6E7FF  !important; 
  font-size: 16px !important;
}
.THSYS {
  background: #FFE8CD  !important; 
  font-size: 16px !important;
}
.THTOT {
  background: #C9C9C9  !important; 
  font-size: 16px !important;
}
.TITLE {
  font-size: 14px !important;
}
#agentScore tbody td,
#agentScore tbody td a {
  font-size: 14px !important;
}
.MAC{
  background: #E8F9FF  !important;
}
.MAC a  {
  color:  #0070C0 !important;
}
.SYS a{
  color:  #BF8F00 !important;
}
.SYS{
  background:#F8F2E5  !important;
}
.TOT{
  background:#EEEEEE  !important;
}
#agentScore.table-bordered th, #agentScore.table-bordered td {
    border: 1px solid #c2c2c2 !important;
}
/* Freeze header row เมื่อ scroll ลง */
#agentScore {
    border-collapse: separate !important;
    border-spacing: 0;
}
#agentScore thead th {
    position: sticky !important;
    top: 0;
    z-index: 10;
    background-clip: padding-box;
}
#agentScore thead tr:nth-child(1) th {
    top: 0;
}
#agentScore thead tr:nth-child(2) th {
    top: 40px;
}
#agentScore td .approved-icon {
    color: #00a651;
    display: block;
    font-size: 0.9em;
    line-height: 1;
    margin-bottom: 2px;
}

/* #agentScore {
    border-collapse: collapse;
}

#agentScore thead th {
    position: sticky;
    background: #fff;
    z-index: 10;
    padding: 6px 8px;
    text-align: center;
} */

/* row 1 */
#agentScore thead tr:nth-child(1) th {
    top: 0;
    height: 50px;
    padding: 6px 8px;
}

/* row 2 */
#agentScore thead tr:nth-child(2) th {
    top: 50px;
    padding: 6px 8px;
    height: 50px;
}
</style>

<!-- 
<template>
  <div class="row">
    <div class="col-xl-12">
    

      <div
        v-show="$route.path == '/AgentScore/JobAgentScore'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fas fa-file-invoice-dollar"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div> 
      </div>
    </div>
     <div class="col-xl-12">
      
    </div>
  </div>
</template> -->


<script>
import Vue from "vue";
import axios from "axios";
import router from "../../router";
import select2 from "../../Shared/Select2";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

require("sweetalert2");


export default {
  components: {
    select2,
    Treeselect,
  },
  data: function () {
    // Generate year options: current year+1 to current year-4
    const currentYear = new Date().getFullYear();
    const yearData = [
      { id: (currentYear + 1).toString(), text: (currentYear + 1).toString() },
      { id: currentYear.toString(), text: currentYear.toString() },
      { id: (currentYear - 1).toString(), text: (currentYear - 1).toString() },
      { id: (currentYear - 2).toString(), text: (currentYear - 2).toString() },
      { id: (currentYear - 3).toString(), text: (currentYear - 3).toString() },
      { id: (currentYear - 4).toString(), text: (currentYear - 4).toString() },
    ];

    return {
      EvaluationId : 0 ,
      currentMonth : 0,
      currentTypeCode : "SYSTEM",
      currentScoreNew : null,
      currentScore : null,
      currentRemark : null,
      searchYear: currentYear.toString(),
      searchAgentCode: [],
      searchAgentOptions: [],
      yearOptions: {
        placeholder: "เลือกปีงบประมาณ",
        allowClear: true,
        data: yearData,
      } ,
      statusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "MY_APPROVAL", text: "ใบงานที่ต้องอนุมัติ" },
          { id: "DRAFT", text: "บันทึก" }, 
          { id: "WAITING_CONFIRM", text: "รอยืนยัน" },
          { id: "COMPLETED", text: "ดำเนินการเรียบร้อย" },
          { id: "CANCELED", text: "ยกเลิก" },
        ],
      },
      dataTable: null, 
      dataSource : [],
      dataSourceRemark : [],
    };
  },
  methods: {
    formReset: function (e) {
    //   const currentYear = new Date().getFullYear();
    //   this.searchYear = currentYear.toString(); 
    //   this.searchStatus = null;

    //   // Reset all Select2 dropdowns
    //   $("#searchYear").val(currentYear.toString()).trigger("change"); 
    //   $("#searchStatus").val(null).trigger("change");

    //   // Reload filter dropdowns
    //  // this.loadFilterDropdowns();

      // Reload table
      this.formSubmit(e);
    },
    formSubmit: function (e) {
      if (e) e.preventDefault();
      
    },  
    formSubmit2: function (e) { 
      if (e) e.preventDefault();
      
    },   
    loadAgentOptions() {
      var self = this;
      axios
        .post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT", {
          province_id: [],
          department: [],
          AgentCodes: [],
          page: 1,
          IsShowInAgentScoreReport: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.searchAgentOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    loadAgentScore() {

      self = this ;
      
      KTApp.blockPage({
        opacity: 0.05,
        message: "กรุณารอสักครู่...",
      });  

      var params = {};
      if (self.searchYear) {
        params.Year = self.searchYear;
      }
      if (self.searchAgentCode && self.searchAgentCode.length > 0) {
        params.AgentCodeSap = self.searchAgentCode;
      }

      try {
          axios({
            method: "post",
            url: "/Api/AgentScore/AgentScoreEvalation",
            data: params,
          })
          .then(function(response) {
            self.dataSource = response.data ;
          })
          .catch(function(error) {
            Swal.fire(
              "เกิดข้อผิดพลาด",
              error.response.data.message,
              "error"
            ).then(function() { });
          })
          .then(function() {
            // always executed
            KTApp.unblockPage();
          });
      } catch (error) {
        console.error("Error load score data:", error);
      }

    },  
    ApproveJobAgentEvaluationALL : function(e){
       let self = this;  
        var data = {
            Year : self.searchYear ,
            StatusCode: 'APPROVE',
            All: true
          };

        let data_len = self.dataSource.length ; 
        if(data_len <= 0){
           Swal.fire(
              "เกิดข้อผิดพลาด",
              "ไม่พบข้อมูลที่ต้องการยืนยัน",
              "error"
            ).then(function() { });
        }
        else{
          Swal.fire({
          title: "ยืนยัน",
          type: "warning",
          html:
            "ต้องการยืนยันทุกตัวแทนจำหน่ายใช่หรือไม่? " ,
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true,
          }).then((result) => {
            if (result.value) { 
              
              KTApp.blockPage({
                  opacity: 0.05,
                  message: "กรุณารอสักครู่...",
                });
                axios
                .post("/Api/AgentScore/ApproveJobAgentEvaluationALL", data)
                .then((response) => { 
                  if (response.data) {
                    this.loadAgentScore();    
                  } else {
                    Swal.fire("เกิดข้อผิดพลาด", response.message, "error");
                  }

                })
                .catch(function(error) {
                  console.log(error);
                  Swal.fire("เกิดข้อผิดพลาด", error.response.message, "error");
                })
                .then(function() { 
                  KTApp.unblockPage(); 
                });
                    
            }
          });
        } 
      
      }, 
    ApproveJobAgentEvaluation(evaluationId,statusCode) { 
      let self = this; 
 
      KTApp.blockPage({
        opacity: 0.05,
        message: "กรุณารอสักครู่...",
      });

       var data = { 
          evaluationId: evaluationId, 
          statusCode: statusCode
        };


      axios
        .post("/Api/AgentScore/ApproveJobAgentEvaluation", data)
        .then((response) => { 
          if (response.data) {
            this.loadAgentScore();    
          } else {
            Swal.fire("เกิดข้อผิดพลาด", response.message, "error");
          }

        })
        .catch(function(error) {
          console.log(error);
          Swal.fire("เกิดข้อผิดพลาด", error.response.message, "error");
        })
        .then(function() { 
          KTApp.unblockPage(); 
        });
    
    }, 
    SaveCommentEdit : function (e) { 
      let self = this; 

      const form = $(this.$refs.editForm); 
      if (!form.valid()) {
         return ;
      }
      else{
          if (self.currentScoreNew !== null && self.currentScoreNew !== '') {
            var data = {
              monthNo : self.currentMonth ,
              evaluationId: self.EvaluationId,
              oldScore: self.currentScore || 0,
              NewScore: self.currentScoreNew,
              Remark: self.currentRemark,
              typeCode: self.currentTypeCode
            };

            KTApp.blockPage({
              opacity: 0.05,
              message: "กรุณารอสักครู่...",
            });
    
            axios
              .post("/Api/AgentScore/AddJobAgentEvaluationScoreRemarkLog", data)
              .then((response) => { 
                if (response.data) {
                  this.loadAgentScore();    
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", response.message, "error");
                }

              })
              .catch(function(error) {
                console.log(error);
                Swal.fire("เกิดข้อผิดพลาด", error.response.message, "error");
              })
              .then(function() { 
                KTApp.unblockPage(); 
              });
            // -- End Submit Barcode
          }

          $('#EditModal').modal('hide');
      } 
    
    }, 
    initEditValidator() {
        const form = $(this.$refs.editForm);

        // ลบ instance เก่าก่อน
        if (form.data('validator')) {
          form.validate().destroy();
        }

        form.validate({
          ignore: [],
          rules: {
            currentScoreNew: {
              required: true,
              number: true,
              min: 0
            },
            currentRemark: {
              required: true
            }
          },
          messages: {
            currentScoreNew: {
              required: "กรุณากรอกคะแนน",
              number: "กรุณากรอกตัวเลข",
              min: "คะแนนต้องไม่น้อยกว่า 0"
            },
            currentRemark: {
              required: "กรุณากรอกหมายเหตุ"
            }
          }
        });
      },
    showModal(evaluationId,month,typecode,score,remark) { 
       
      let self = this ;
      setTimeout(function() {
          self.EvaluationId = evaluationId ;
          self.currentMonth = month ;
          self.currentTypeCode = typecode ;
          self.currentScoreNew = score ;
          self.currentScore = score ;
          self.currentRemark = '' ;
        
      }, 50); 

      self.dataSourceRemark = [] ;
      
      KTApp.blockPage({
        opacity: 0.05,
        message: "กรุณารอสักครู่...",
      });
 
      try {
         axios({
          method: "get",
          url: "/Api/AgentScore/GetAgentScoreEvalationRemark?evalid="+evaluationId+"&month="+month+"&typecode="+typecode, 
        })
        .then(function(response) { 

            if (response.status == 200) {
                var data = response.data ;
                
                setTimeout(function() {
                   data.forEach((element) => {
                    self.dataSourceRemark.push({
                        logId:  element.logId,
                        scoreId: element.scoreId,
                        oldScore: element.oldScore,
                        newScore: element.newScore,
                        remark: element.remark,
                        actionType: element.actionType,
                        createdUserId: element.createdUserId,
                        createdDateText:  moment(element.createdDate).format('DD/MM/YYYY HH:mm:ss'),
                        createdDate : element.createdDate,
                        updatedUserId: element.updatedUserId,
                        updatedDate: element.updatedDate,
                        firstName: element.firstName,
                        lastName: element.lastName,
                        fullName: element.fullName,
                        monthNo: element.monthNo,
                        evaluationId: element.evaluationId,
                        typeCode: element.typeCode
                    });
                  });

                  console.log( self.dataSourceRemark);
                  
                }, 50);
                
                
            } 
          
        })
        .catch(function(error) {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            error.response.data.message,
            "error"
          ).then(function() {
             
          });
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
      } catch (error) {
        console.error("Error load score data:", error);
      }

      // $('#EditModal').on('shown.bs.modal', () => {
      //   $('body').addClass('modal-open');
       
      // });

      $('#EditModal').modal('show');
        $('#EditModal').off('shown.bs.modal').on('hidden.bs.modal', () => {
        $('body').addClass('modal-open');  
      });

      this.$nextTick(() => {
        this.initEditValidator();
      });

    },
    closeModal() {
      $('#EditModal').modal('hide');
    }, 
    
  },
 mounted()
  {
    // Load job types and filter dropdowns
    let self = this;
    this.loadAgentOptions();
    this.loadAgentScore();

    // Set default year
     this.$nextTick();
    const currentYear = new Date().getFullYear();
    $("#searchYear").val(currentYear.toString()).trigger("change");
  
    // $(self.$refs.editForm).validate({
    //   ignore: ":hidden, .ignore",
    //   rules: {
    //     currentScoreNew: "required",
    //     currentRemark: "required", 
    //   },
    //   messages: {
    //     currentScoreNew: "กรุณากรอกคะแนน",
    //     currentRemark: "กรุณากรอกหมายเหตุ", 
    //   },
    // });

  },
  watch: {
    '$route.query.reload': function() {
      // Reload datatable when returning from form with reload query param
      if (this.dataTable) {
        this.dataTable.ajax.reload();
      }
    },
    searchYear: function(newVal, oldVal) {

        this.loadAgentScore();
    },
    searchAgentCode: function(newVal, oldVal) {
        this.loadAgentScore();
    },
     
  },
};
</script>

<style lang="scss">
.select2,
.select2-dropdown {
  font-size: 1rem !important;
}
</style>



// WEBPACK FOOTER //
// App/Components/AgentScore/AgentScoreList.vue